var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { getIcon } from '../utils/getIcon';
import { getImage } from '../utils/getImage';
import { NavTabsV1, PoolDetailsV1, NotificationComp, PositionRangeV1, LpBreakdownDetailV1, VaultDetailsStrategyV1, AssetDetailsV1, PoolInfoCardV1, RewardsBreakdownV1, 
// useWindowSizes,
convertToKAndM, LoaderComp, commaFy, } from 'ui-kit';
import { useMemo, useState, useEffect } from 'react';
import { useEventSubscription, useSubscription } from '../hooks';
import { useSignAndExecuteTransaction } from '@mysten/dapp-kit';
import { useNetworkString } from '../context/NetworkContext';
import { useBalances } from '../context/BalanceContext';
import { transactionHandler } from '../utils/transactionHandlers';
import { createAlphaFiSDK } from '../utils/networkUtils';
import { getButtonState } from '../utils/buttonStateUtils';
import { getDecimalPlaces } from '../utils/currencyUtils';
import { useNavigate } from 'react-router-dom';
const PoolDetailsPage = ({ themeName, address, walletConnectFunctionality, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const [searchParams] = useSearchParams();
    // const { isLargeTablet, isDesktop } = useWindowSizes();
    const poolId = searchParams.get('id');
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const network = useNetworkString();
    const { walletBalancesMap } = useBalances();
    const { mutate: signAndExecuteTransaction } = useSignAndExecuteTransaction();
    const { data: staticData } = useEventSubscription('system', 'static_data');
    const { data: protocolData } = useSubscription('protocol');
    const poolDetailsRoom = poolId ? `pool_details:${poolId}` : '';
    const { data: poolDetailsData } = useSubscription(poolDetailsRoom);
    const { data: coinInfoData } = useSubscription('coin_info');
    const { data: Portfolio } = useSubscription(address ? `portfolio:${address}` : null);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isZapInActive, setIsZapInActive] = useState(false);
    const [zapInQuoteDetails, setZapInQuoteDetails] = useState({
        zapInLoader: true,
        zapInQuoteLoader: false,
        poolDetailsPage: true,
    });
    const [slippage, setSlippage] = useState(1);
    const fetchParentProtocolIconArray = (parent_protocol_name) => {
        const protocolIcons = parent_protocol_name.map((protocol) => getIcon(protocol.toLowerCase()));
        return protocolIcons;
    };
    const poolData = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const staticPoolData = poolId ? staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId) : undefined;
        if (!staticPoolData) {
            return undefined;
        }
        let leverageTokens = [];
        const assetArray = Object.values(coinInfoData || {});
        let isLeveragedPool = false;
        if (staticPoolData.strategy_type_headers[0] === 'Leveraged Yield Farming' &&
            walletBalancesMap) {
            isLeveragedPool = true;
            const missingToken = staticPoolData.asset_details.filter((asset) => {
                return asset.asset !== staticPoolData.asset_types[0].asset_symbol;
            });
            if (missingToken && missingToken.length > 0) {
                const missingTokenDetails = assetArray === null || assetArray === void 0 ? void 0 : assetArray.filter((token) => missingToken[0].asset === token.symbol);
                if (missingTokenDetails && missingTokenDetails.length > 0) {
                    leverageTokens = [
                        {
                            asset_type: missingTokenDetails[0].coinType,
                            asset_symbol: missingTokenDetails[0].symbol,
                            asset_decimals: parseFloat(missingTokenDetails[0].decimals),
                        },
                        staticPoolData.asset_types[0],
                    ];
                }
            }
        }
        const baseData = {
            name: staticPoolData.pool_name,
            protocol_name: staticPoolData.parent_protocol_name,
            protocol_icon: fetchParentProtocolIconArray(staticPoolData.parent_protocol_name),
            strategy_name: staticPoolData.strategy_type_headers[0],
            protocolType: [`${staticPoolData.strategy_type_headers[0]}`],
            tvl: convertToKAndM((() => {
                var _a;
                if (!(staticPoolData === null || staticPoolData === void 0 ? void 0 : staticPoolData.pool_id) || !(protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data)) {
                    return '0';
                }
                const poolTvl = (_a = protocolData.pools_data[staticPoolData.pool_id]) === null || _a === void 0 ? void 0 : _a.tvl;
                return poolTvl || '0';
            })()),
            daily: (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr) && (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr) !== 'NaN'
                ? `${parseFloat((poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr) || '0').toFixed(4)}%`
                : '',
            apy: `${parseFloat(((_b = (_a = protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) === null || _a === void 0 ? void 0 : _a[staticPoolData.pool_id]) === null || _b === void 0 ? void 0 : _b.apy) || '0').toFixed(2)}%`,
            leverage: `${parseFloat(((_d = (_c = protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) === null || _c === void 0 ? void 0 : _c[staticPoolData.pool_id]) === null || _d === void 0 ? void 0 : _d.about_strategy_labels.leverage) || '0').toFixed(2)}x`,
            lastCompoundTime: (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.last_compound) || 'N/A',
            yourDeposit: parseFloat(((_f = (_e = Portfolio === null || Portfolio === void 0 ? void 0 : Portfolio.pool_balances) === null || _e === void 0 ? void 0 : _e[staticPoolData.pool_id]) === null || _f === void 0 ? void 0 : _f.balance_usd) || '0').toFixed(2),
            assetDetails: staticPoolData.asset_details.map((asset) => {
                var _a, _b, _c;
                const assetType = (_a = staticPoolData.asset_types.find((at) => at.asset_symbol === asset.asset)) === null || _a === void 0 ? void 0 : _a.asset_type;
                return {
                    name: asset.asset,
                    symbol: asset.asset,
                    price: assetType
                        ? ((_b = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[assetType]) === null || _b === void 0 ? void 0 : _b.price) || '0'
                        : ((_c = assetArray === null || assetArray === void 0 ? void 0 : assetArray.find((token) => token.symbol === asset.asset)) === null || _c === void 0 ? void 0 : _c.price) || '0',
                    logoUrl: getIcon(asset.asset.toLowerCase(), asset.asset),
                    description: asset.details,
                    links: {
                        website: asset.website_url,
                        contract: asset.contract_url,
                        docs: asset.docs_url,
                    },
                };
            }),
            positionRange: (() => {
                var _a;
                const poolData = (_a = protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) === null || _a === void 0 ? void 0 : _a[staticPoolData.pool_id];
                if (poolData && 'position_range' in poolData && poolData.position_range) {
                    return [
                        {
                            title: 'MIN PRICE',
                            value: Number(poolData.position_range.lower).toFixed(5),
                            poolName: staticPoolData.pool_name,
                        },
                        {
                            title: 'CURRENT PRICE',
                            value: (staticPoolData.is_reversed
                                ? 1 / Number(poolData.position_range.current_price)
                                : Number(poolData.position_range.current_price)).toFixed(5),
                            poolName: staticPoolData.pool_name,
                            rangeStatus: Number(poolData.position_range.lower) <=
                                Number(poolData.position_range.current_price) &&
                                Number(poolData.position_range.current_price) <=
                                    Number(poolData.position_range.upper)
                                ? 'inRange'
                                : 'outOfRange',
                        },
                        {
                            title: 'MAX PRICE',
                            value: Number(poolData.position_range.upper).toFixed(5),
                            poolName: staticPoolData.pool_name,
                        },
                    ];
                }
                return undefined;
            })(),
            strategyDetails: {
                title: 'Strategy',
                contracts: staticPoolData.strategy_details.contracts.map((contract) => ({
                    name: contract.label === 'Alpha Contract' ? 'AlphaFi Contract' : contract.label,
                    link: contract.url,
                    icon: themeName === 'dark' ? getIcon('externalIconWhite') : getIcon('externalIconDark'),
                })),
                strategy: {
                    description: staticPoolData.strategy_details.paragraphs,
                    warnings: {
                        fungibleTokenWarning: false,
                    },
                },
                fees: {
                    performance: `${(_h = (_g = protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) === null || _g === void 0 ? void 0 : _g[staticPoolData.pool_id]) === null || _h === void 0 ? void 0 : _h.about_strategy_labels.performance_fee}% of the Yield`,
                    specialNotes: {
                        noDepositWithdrawal: 'We prioritize your capital. Your deposit amount remains untouched, and our fee is only applied to the yield generated, ensuring you get the most out of your investment.',
                    },
                },
                audits: staticPoolData.strategy_details.audits.map((audit) => ({
                    name: audit.label,
                    link: audit.url,
                })),
            },
            rewardsBreakdown: {
                text: staticPoolData.rewards_breakdown.strategy_benefits.map((benefit) => `${benefit.label}: ${benefit.value}`),
                items: (poolId &&
                    ((_l = (_k = (_j = protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) === null || _j === void 0 ? void 0 : _j[poolId]) === null || _k === void 0 ? void 0 : _k.apy_hover) === null || _l === void 0 ? void 0 : _l.map((aprItem, index) => ({
                        label: aprItem.label,
                        value: aprItem.value
                            ? `${String(aprItem.value).slice(0, String(aprItem.value).indexOf('.') + 3)}%`
                            : '0%',
                        icon: index === 0
                            ? themeName === 'dark'
                                ? getIcon('whiteRefreshIcon')
                                : getIcon('refreshIcon')
                            : undefined,
                        highlighted: aprItem.label === 'APY',
                    })))) ||
                    [],
                tooltipItems: [
                    {
                        value: ((_m = poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.rewards_breakdown) === null || _m === void 0 ? void 0 : _m.autocompounding_frequency)
                            ? `Rewards are converted into the deposit token and reinvested every ${poolDetailsData.rewards_breakdown.autocompounding_frequency}, increasing your holdings.`
                            : 'Rewards are converted into the deposit token and reinvested every 2 hours, increasing your holdings.',
                    },
                ],
                secondCard: {
                    title: 'ALPHA Locked Vault',
                    description: ((_o = poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.rewards_breakdown) === null || _o === void 0 ? void 0 : _o.alpha_locked_apr)
                        ? `Earns an Additional ${poolDetailsData.rewards_breakdown.alpha_locked_apr}% APY Eligible for Periodic Airdrops`
                        : 'Earns an Additional 10% APY Eligible for Periodic Airdrops',
                    alphaLockedIcon: {
                        alphaIcon: getIcon('alpha'),
                        lockIcon: getIcon('lockIcon'),
                    },
                    icon2: getIcon('refreshIcon'),
                },
            },
            navTabs: (() => {
                if (staticPoolData.pool_name === 'ALPHA') {
                    return [
                        { label: 'Deposit', disabled: false },
                        { label: 'Withdraw', disabled: false, navigateTo: '/airdrop', isNavigation: true },
                        {
                            label: 'Locked',
                            disabled: false,
                            navigateTo: '/airdrop',
                            isNavigation: true,
                        },
                    ];
                }
                return [
                    { label: 'Deposit', disabled: false },
                    { label: 'Withdraw', disabled: false },
                ];
            })(),
        };
        const tokensList = staticPoolData.strategy_type_headers[0] === 'Leveraged Yield Farming' &&
            leverageTokens &&
            leverageTokens.length > 0
            ? leverageTokens
            : staticPoolData.asset_types;
        const tokens = staticPoolData.asset_types.map((asset) => {
            var _a;
            return ({
                symbol: asset.asset_symbol,
                name: asset.asset_symbol,
                icon: getIcon(asset.asset_symbol.toLowerCase(), asset.asset_symbol),
                walletBalance: activeTabIndex === 0
                    ? (parseFloat((walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get(asset.asset_type)) || '0') /
                        Math.pow(10, asset.asset_decimals)).toString()
                    : (() => {
                        var _a;
                        const poolBalance = poolId ? (_a = Portfolio === null || Portfolio === void 0 ? void 0 : Portfolio.pool_balances) === null || _a === void 0 ? void 0 : _a[poolId] : undefined;
                        if (!poolBalance)
                            return '0';
                        if ('balances' in poolBalance && poolBalance.balances) {
                            const tokenBalance = poolBalance.balances.find((balance) => balance.label.toUpperCase() === asset.asset_symbol.toUpperCase());
                            if (!tokenBalance && asset.asset_symbol.toUpperCase() === 'ALPHA') {
                                const lockedBalance = poolBalance.balances.find((b) => b.label === 'alpha_locked');
                                const unlockedBalance = poolBalance.balances.find((b) => b.label === 'alpha_unlocked');
                                if (lockedBalance || unlockedBalance) {
                                    const locked = parseFloat((lockedBalance === null || lockedBalance === void 0 ? void 0 : lockedBalance.value) || '0');
                                    const unlockedRaw = parseFloat((unlockedBalance === null || unlockedBalance === void 0 ? void 0 : unlockedBalance.value) || '0');
                                    const unlocked = unlockedRaw / Math.pow(10, asset.asset_decimals);
                                    return (locked + unlocked).toString();
                                }
                            }
                            return (tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.value) || '0';
                        }
                        return '0';
                    })(),
                price: ((_a = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[asset.asset_type]) === null || _a === void 0 ? void 0 : _a.price) || '0',
            });
        });
        const tokensForDisplay = tokensList.map((asset) => {
            var _a;
            return ({
                symbol: asset.asset_symbol,
                name: asset.asset_symbol,
                icon: getIcon(asset.asset_symbol.toLowerCase(), asset.asset_symbol),
                walletBalance: activeTabIndex === 0
                    ? (parseFloat((walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get(asset.asset_type)) || '0') /
                        Math.pow(10, asset.asset_decimals)).toString()
                    : (() => {
                        var _a;
                        const poolBalance = poolId ? (_a = Portfolio === null || Portfolio === void 0 ? void 0 : Portfolio.pool_balances) === null || _a === void 0 ? void 0 : _a[poolId] : undefined;
                        if (!poolBalance)
                            return '0';
                        if ('balances' in poolBalance && poolBalance.balances) {
                            const tokenBalance = poolBalance.balances.find((balance) => balance.label.toUpperCase() === asset.asset_symbol.toUpperCase());
                            if (!tokenBalance && asset.asset_symbol.toUpperCase() === 'ALPHA') {
                                const lockedBalance = poolBalance.balances.find((b) => b.label === 'alpha_locked');
                                const unlockedBalance = poolBalance.balances.find((b) => b.label === 'alpha_unlocked');
                                if (lockedBalance || unlockedBalance) {
                                    const locked = parseFloat((lockedBalance === null || lockedBalance === void 0 ? void 0 : lockedBalance.value) || '0');
                                    const unlockedRaw = parseFloat((unlockedBalance === null || unlockedBalance === void 0 ? void 0 : unlockedBalance.value) || '0');
                                    const unlocked = unlockedRaw / Math.pow(10, asset.asset_decimals);
                                    return (locked + unlocked).toString();
                                }
                            }
                            return (tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.value) || '0';
                        }
                        return '0';
                    })(),
                price: ((_a = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[asset.asset_type]) === null || _a === void 0 ? void 0 : _a.price) || '0',
            });
        });
        const lpBreakdown = (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.pool_type) === 'double_asset' &&
            poolDetailsData.lp_breakdown
            ? {
                tokenShareInPool: poolDetailsData.lp_breakdown.alphafi_pool.asset_percentages.map((percentage) => parseFloat(percentage) / 100),
                tokenIcons: {
                    token1: ((_p = tokensForDisplay[0]) === null || _p === void 0 ? void 0 : _p.icon) || '',
                    token2: ((_q = tokensForDisplay[1]) === null || _q === void 0 ? void 0 : _q.icon) || '',
                },
                assets: {
                    alphaFi: poolDetailsData.lp_breakdown.alphafi_pool.table.map((asset, index) => {
                        const getTokensForAsset = (assetName) => {
                            if (assetName.includes('-') && tokensForDisplay.length === 2) {
                                return tokensForDisplay;
                            }
                            const poolToken = Object.assign(Object.assign({}, tokensForDisplay[index]), { name: tokensForDisplay[0].name + '-' + assetName });
                            return poolToken ? [poolToken] : tokensForDisplay;
                        };
                        return {
                            tokens: getTokensForAsset(isLeveragedPool && index === 2
                                ? tokensForDisplay[0].name + '-' + asset.asset
                                : asset.asset),
                            name: isLeveragedPool && index === 2
                                ? tokensForDisplay[0].name + '-' + asset.asset
                                : asset.asset,
                            icon: getIcon(asset.asset.toLowerCase(), asset.asset),
                            amount: commaFy(Number(asset.amount).toFixed(0)),
                            value: commaFy(Number(asset.value).toFixed(0)),
                        };
                    }),
                    underlyingPool: poolDetailsData.lp_breakdown.parent_pool.table.map((asset, index) => {
                        const getTokensForAsset = (assetName) => {
                            if (assetName.includes('-') && tokensForDisplay.length === 2) {
                                return tokensForDisplay;
                            }
                            const matchingToken = tokensForDisplay.find((token) => assetName.toLowerCase().includes(token.symbol.toLowerCase()) ||
                                token.symbol.toLowerCase().includes(assetName.toLowerCase()));
                            return matchingToken ? [matchingToken] : tokens;
                        };
                        return {
                            tokens: getTokensForAsset(isLeveragedPool && index === 2
                                ? tokensForDisplay[0].name + '-' + asset.asset
                                : asset.asset),
                            name: isLeveragedPool && index === 2
                                ? tokensForDisplay[0].name + '-' + asset.asset
                                : asset.asset,
                            icon: getIcon(asset.asset.toLowerCase(), asset.asset),
                            amount: commaFy(Number(asset.amount).toFixed(0)),
                            value: commaFy(Number(asset.value).toFixed(0)),
                        };
                    }),
                },
            }
            : undefined;
        return Object.assign(Object.assign(Object.assign({}, baseData), { tokens,
            tokensForDisplay }), (lpBreakdown && { lpBreakdown }));
    }, [
        poolId,
        staticData,
        protocolData,
        poolDetailsData,
        themeName,
        activeTabIndex,
        walletBalancesMap,
        Portfolio,
        coinInfoData,
    ]);
    const [notificationInfo, setNotificationInfo] = useState({
        title: '',
        description: '',
        spinner: false,
        link: '',
        image: undefined,
    });
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tokenValues, setTokenValues] = useState({});
    const [lpBreakdownActiveTab, setLpBreakdownActiveTab] = useState('alphaFi');
    const [isMaxClicked, setIsMaxClicked] = useState(false);
    const suiBalance = (walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get('0x2::sui::SUI')) || '0';
    const handleDeposit = (amounts) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!address || !poolId) {
            console.error('No wallet connected or poolId missing');
            return;
        }
        const formattedAmounts = Object.entries(amounts)
            .map(([coin, amount]) => `${Number(amount).toFixed(getDecimalPlaces(coin))} ${coin}`)
            .join(' and ');
        const tokenSymbols = Object.keys(amounts);
        const isAmountA = tokenSymbols.length > 1 ? tokenSymbols.indexOf(Object.keys(amounts)[0]) === 0 : undefined;
        const amount = Object.values(amounts)[0];
        const firstTokenSymbol = tokenSymbols[0];
        const poolStatic = staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId);
        const firstAssetType = (_b = (_a = poolStatic === null || poolStatic === void 0 ? void 0 : poolStatic.asset_types) === null || _a === void 0 ? void 0 : _a.find((asset) => asset.asset_symbol === firstTokenSymbol)) === null || _b === void 0 ? void 0 : _b.asset_type;
        try {
            yield transactionHandler({
                poolName: poolData === null || poolData === void 0 ? void 0 : poolData.name,
                amount: amount,
                poolId: poolId,
                decimals: (firstAssetType && ((_c = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[firstAssetType]) === null || _c === void 0 ? void 0 : _c.decimals)) || '',
                network: network,
                action: 'deposit',
                modalState: {
                    isOpen: true,
                    token: (poolData === null || poolData === void 0 ? void 0 : poolData.tokens[0]) || null,
                    actionType: 'deposit',
                },
                address: address,
                signAndExecuteTransaction: signAndExecuteTransaction,
                setNotificationInfo: setNotificationInfo,
                setIsNotificationOpen: setIsNotificationOpen,
                setIsTransactionLoading: setLoading,
                displayAmount: formattedAmounts,
                suiBalance: suiBalance,
                isAmountA: isAmountA,
                resetInputValues: () => {
                    setTokenValues({});
                },
            });
        }
        catch (error) {
            console.error('Deposit failed:', error);
        }
    });
    const handleZapInAndDeposit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!address || !poolId) {
            console.error('No wallet connected or poolId missing');
            return;
        }
        const formattedAmounts = `${zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.token1Amount} ${zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.token1Symbol} and ${zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.token2Amount} ${zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.token2Symbol}`;
        const poolStatic = staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId);
        const activeAsset = (_b = (_a = poolStatic === null || poolStatic === void 0 ? void 0 : poolStatic.asset_types) === null || _a === void 0 ? void 0 : _a.find((asset) => asset.asset_symbol === (zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.activeToken))) === null || _b === void 0 ? void 0 : _b.asset_type;
        try {
            yield transactionHandler({
                poolName: poolData === null || poolData === void 0 ? void 0 : poolData.name,
                amount: (zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.depositAmountWithoutExponent) || '0',
                poolId: poolId,
                decimals: (activeAsset && ((_c = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[activeAsset]) === null || _c === void 0 ? void 0 : _c.decimals)) || '',
                network: network,
                action: 'zap_deposit',
                modalState: {
                    isOpen: true,
                    token: (poolData === null || poolData === void 0 ? void 0 : poolData.tokens[0]) || null,
                    actionType: 'zap_deposit',
                },
                address: address,
                signAndExecuteTransaction: signAndExecuteTransaction,
                setNotificationInfo: setNotificationInfo,
                setIsNotificationOpen: setIsNotificationOpen,
                setIsTransactionLoading: setLoading,
                displayAmount: formattedAmounts,
                suiBalance: suiBalance,
                isAmountA: zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.isInputA,
                slippage: slippage,
                resetInputValues: () => {
                    setTokenValues({});
                    setZapInQuoteDetails((prev) => (Object.assign(Object.assign({}, prev), { zapInLoader: true, zapInQuoteLoader: false, poolId: poolId, poolDetailsPage: true, zapSlippage: '' })));
                },
            });
        }
        catch (error) {
            console.error('Deposit failed:', error);
        }
    });
    const handleWithdraw = (amounts) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!address || !poolId) {
            console.error('No wallet connected or poolId missing');
            return;
        }
        const formattedAmounts = Object.entries(amounts)
            .map(([coin, amount]) => `${Number(amount).toFixed(getDecimalPlaces(coin))} ${coin}`)
            .join(' and ');
        const tokenSymbols = Object.keys(amounts);
        const isAmountA = tokenSymbols.length > 1 ? tokenSymbols.indexOf(Object.keys(amounts)[0]) === 0 : undefined;
        const amount = Object.values(amounts)[0];
        const firstTokenSymbol = tokenSymbols[0];
        const poolStatic = staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId);
        const firstAssetType = (_b = (_a = poolStatic === null || poolStatic === void 0 ? void 0 : poolStatic.asset_types) === null || _a === void 0 ? void 0 : _a.find((asset) => asset.asset_symbol === firstTokenSymbol)) === null || _b === void 0 ? void 0 : _b.asset_type;
        try {
            yield transactionHandler({
                poolName: poolData === null || poolData === void 0 ? void 0 : poolData.name,
                amount: amount,
                poolId: poolId,
                decimals: (firstAssetType && ((_c = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[firstAssetType]) === null || _c === void 0 ? void 0 : _c.decimals)) || '',
                network: network,
                action: 'withdraw',
                modalState: {
                    isOpen: true,
                    token: (poolData === null || poolData === void 0 ? void 0 : poolData.tokens[0]) || null,
                    actionType: 'withdraw',
                },
                address: address,
                signAndExecuteTransaction: signAndExecuteTransaction,
                setNotificationInfo: setNotificationInfo,
                setIsNotificationOpen: setIsNotificationOpen,
                setIsTransactionLoading: setLoading,
                displayAmount: formattedAmounts,
                suiBalance: suiBalance,
                isAmountA: isAmountA,
                withdrawMax: isMaxClicked,
                resetInputValues: () => {
                    setTokenValues({});
                    setIsMaxClicked(false);
                },
            });
        }
        catch (error) {
            console.error('Withdraw failed:', error);
        }
    });
    const fetchZapInQuote = (depositAmount, isInputA, slippage, tokens) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        try {
            setZapInQuoteDetails({
                zapInLoader: true,
                zapInQuoteLoader: true,
                poolId: poolId || '',
                poolDetailsPage: true,
            });
            const poolDetails = staticData === null || staticData === void 0 ? void 0 : staticData.find((pooldata) => pooldata.pool_id === poolId);
            const tokenDetails = isInputA ? (_a = poolDetails === null || poolDetails === void 0 ? void 0 : poolDetails.asset_types) === null || _a === void 0 ? void 0 : _a[0] : (_b = poolDetails === null || poolDetails === void 0 ? void 0 : poolDetails.asset_types) === null || _b === void 0 ? void 0 : _b[1];
            if (tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.asset_type) {
                const tokenBalance = (parseFloat((walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get(tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.asset_type)) || '0') /
                    Math.pow(10, (tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.asset_decimals)))
                    .toFixed(tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.asset_decimals)
                    .toString();
                if (tokenBalance && parseFloat(tokenBalance) >= parseFloat(depositAmount)) {
                    //fetch get quote from sdk
                    const depositAmountNormalized = (parseFloat(depositAmount) *
                        Math.pow(10, (tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.asset_decimals)))
                        .toString()
                        .split('.')[0];
                    const alphafiSdk = createAlphaFiSDK(network, address || '');
                    const quote = yield alphafiSdk.zapDepositQuote({
                        poolId: (poolDetails === null || poolDetails === void 0 ? void 0 : poolDetails.pool_id) || '',
                        inputCoinAmount: BigInt(depositAmountNormalized),
                        isInputA: isInputA,
                        slippage: slippage / 100 || 0.01,
                    });
                    if (quote && poolDetails) {
                        const token1Amount = (parseFloat(quote[0]) /
                            Math.pow(10, ((_d = (_c = poolDetails === null || poolDetails === void 0 ? void 0 : poolDetails.asset_types) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.asset_decimals)))
                            .toFixed(4)
                            .toString();
                        const token2Amount = (parseFloat(quote[1]) /
                            Math.pow(10, ((_f = (_e = poolDetails === null || poolDetails === void 0 ? void 0 : poolDetails.asset_types) === null || _e === void 0 ? void 0 : _e[1]) === null || _f === void 0 ? void 0 : _f.asset_decimals)))
                            .toFixed(4)
                            .toString();
                        const token1Price = tokens[0].price;
                        const token2Price = tokens[1].price;
                        const token1AmountInUsd = token1Price
                            ? (parseFloat(token1Amount) * parseFloat(token1Price)).toFixed(2).toString()
                            : '0';
                        const token2AmountInUsd = token2Price
                            ? (parseFloat(token2Amount) * parseFloat(token2Price)).toFixed(2).toString()
                            : '0';
                        const inputUSD = token1Price && isInputA
                            ? parseFloat(depositAmount) * parseFloat(token1Price)
                            : token2Price
                                ? parseFloat(depositAmount) * parseFloat(token2Price)
                                : 0;
                        const tokenShareInZap = token1AmountInUsd || token2AmountInUsd
                            ? [
                                ((parseFloat(token1AmountInUsd) * 100) /
                                    (parseFloat(token1AmountInUsd) + parseFloat(token2AmountInUsd)))
                                    .toFixed(2)
                                    .toString(),
                                ((parseFloat(token2AmountInUsd) * 100) /
                                    (parseFloat(token1AmountInUsd) + parseFloat(token2AmountInUsd)))
                                    .toFixed(2)
                                    .toString(),
                            ]
                            : ['0', '0'];
                        const zapSlippage = (((inputUSD - (parseFloat(token1AmountInUsd) + parseFloat(token2AmountInUsd))) * 100) /
                            inputUSD)
                            .toFixed(2)
                            .toString();
                        const swapAmountArray = isInputA
                            ? [
                                (inputUSD - parseFloat(token1AmountInUsd) / parseFloat(token1Price))
                                    .toFixed(4)
                                    .toString(),
                                token2Amount,
                            ]
                            : [
                                token1Amount,
                                (inputUSD - parseFloat(token2AmountInUsd) / parseFloat(token2Price))
                                    .toFixed(4)
                                    .toString(),
                            ];
                        setZapInQuoteDetails({
                            token1Amount,
                            token2Amount,
                            token1AmountInUsd,
                            token2AmountInUsd,
                            token1Icon: tokens[0].icon,
                            token2Icon: tokens[1].icon,
                            tokenShareInZap: tokenShareInZap,
                            zapSlippage,
                            token1Price,
                            token2Price,
                            token1Symbol: tokens[0].symbol,
                            token2Symbol: tokens[1].symbol,
                            isInputA,
                            swapAmountArray,
                            depositAmount: depositAmountNormalized.toString(),
                            zapInIcon: themeName === 'dark' && isZapInActive
                                ? getIcon('zapInIcon')
                                : themeName === 'dark' && !isZapInActive
                                    ? getIcon('zapInIconDarkTheme')
                                    : themeName !== 'dark' && isZapInActive
                                        ? getIcon('zapInIconDarkTheme')
                                        : themeName !== 'dark' && !isZapInActive
                                            ? getIcon('zapInIcon')
                                            : '',
                            reverseIcon: themeName === 'dark'
                                ? getIcon('reverseTokensIconDarkTheme')
                                : getIcon('reverseTokensIcon'),
                            slippageIcon: themeName === 'dark' ? getIcon('whiteSlippageIcon') : getIcon('zapSlippageIcon'),
                            depositsIcon: themeName === 'dark'
                                ? getIcon('depositsIconForDarkTheme')
                                : getIcon('depositsIcon'),
                            zapInLoader: false,
                            zapInQuoteLoader: false,
                            poolId: poolId || '',
                            activeToken: isInputA ? tokens[0].symbol : tokens[1].symbol,
                            depositAmountWithoutExponent: depositAmount.toString(),
                            customZapSlippagePopupStyle: 'absolute left-[75%] mt-[25px] z-50',
                            poolDetailsPage: true,
                        });
                    }
                }
                else {
                    setZapInQuoteDetails({
                        zapInLoader: true,
                        zapInQuoteLoader: false,
                        poolId: poolId || '',
                        activeToken: isInputA ? tokens[0].symbol : tokens[1].symbol,
                        poolDetailsPage: true,
                    });
                }
            }
        }
        catch (error) {
            console.log('error in fetching zapin quote', error);
        }
    });
    if (!poolData) {
        return (_jsx("div", { className: "flex items-center justify-center h-screen mt-[-4vw] theme-bg-alphafi-primary", children: _jsx(LoaderComp, { dimensions: "w-[9vw] md:w-[3vw] h-[9vw] md:h-[3vw]", borderWidth: "border-[0.5vw]" }) }));
    }
    if (Object.keys(tokenValues).length === 0) {
        const initialValues = {};
        poolData.tokens.forEach((token) => {
            initialValues[token.symbol] = '';
        });
        setTokenValues(initialValues);
    }
    const calculateTokenRatios = (inputTokenSymbol, inputValue, poolTokens) => {
        var _a, _b, _c;
        const amount = parseFloat(inputValue);
        if (!inputValue.trim() || isNaN(amount) || amount === 0 || !poolId) {
            return Object.fromEntries(poolTokens.map((t) => [t.symbol, '']));
        }
        if (poolTokens.length === 1) {
            return { [inputTokenSymbol]: inputValue };
        }
        const immediateResult = Object.fromEntries(poolTokens.map((t) => [t.symbol, t.symbol === inputTokenSymbol ? inputValue : '']));
        try {
            const poolStatic = staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId);
            const inputAssetType = (_b = (_a = poolStatic === null || poolStatic === void 0 ? void 0 : poolStatic.asset_types) === null || _a === void 0 ? void 0 : _a.find((a) => a.asset_symbol === inputTokenSymbol)) === null || _b === void 0 ? void 0 : _b.asset_type;
            const inputDecimals = Number(((_c = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[inputAssetType || '']) === null || _c === void 0 ? void 0 : _c.decimals) || 0);
            const amountInSmallestUnit = (amount * Math.pow(10, inputDecimals)).toString();
            const alphafiSdk = createAlphaFiSDK(network, address || '');
            const isAmountA = poolTokens[0].symbol === inputTokenSymbol;
            alphafiSdk
                .estimateLpAmounts({ poolId, amount: amountInSmallestUnit, isAmountA })
                .then(([amount1, amount2]) => {
                var _a, _b, _c;
                const tokenASymbol = poolTokens[0].symbol;
                const otherToken = poolTokens.find((t) => t.symbol !== inputTokenSymbol);
                if (!otherToken)
                    return;
                const otherAssetType = (_b = (_a = poolStatic === null || poolStatic === void 0 ? void 0 : poolStatic.asset_types) === null || _a === void 0 ? void 0 : _a.find((a) => a.asset_symbol === otherToken.symbol)) === null || _b === void 0 ? void 0 : _b.asset_type;
                const otherDecimals = Number(((_c = coinInfoData === null || coinInfoData === void 0 ? void 0 : coinInfoData[otherAssetType || '']) === null || _c === void 0 ? void 0 : _c.decimals) || 0);
                const smallestUnit = otherToken.symbol === tokenASymbol ? amount1 : amount2;
                const otherValueRaw = parseFloat(smallestUnit) / Math.pow(10, otherDecimals);
                const otherValue = otherValueRaw < 1
                    ? parseFloat(otherValueRaw.toFixed(8)).toString()
                    : parseFloat(otherValueRaw.toFixed(6)).toString();
                setTokenValues((prev) => (Object.assign(Object.assign({}, prev), { [inputTokenSymbol]: inputValue, [otherToken.symbol]: otherValue })));
            })
                .catch((err) => console.error('🔍 SDK Error calculating token ratios:', err));
        }
        catch (err) {
            console.error('⚠️ Error in calculateTokenRatios:', err);
        }
        return immediateResult;
    };
    const updateTokenValues = (tokenSymbol, value) => {
        var _a, _b;
        setIsMaxClicked(false);
        if (value.trim() === '') {
            const clearedValues = poolData
                ? Object.fromEntries(poolData.tokens.map((t) => [t.symbol, '']))
                : { [tokenSymbol]: '' };
            setTokenValues(clearedValues);
            if (poolId) {
                setZapInQuoteDetails({
                    zapInLoader: true,
                    zapInQuoteLoader: false,
                    poolId: ((_a = staticData === null || staticData === void 0 ? void 0 : staticData.find((pool) => pool.pool_id === poolId)) === null || _a === void 0 ? void 0 : _a.strategy_type_headers[0]) ===
                        'Leveraged Yield Farming'
                        ? ''
                        : poolId,
                    poolDetailsPage: true,
                    zapSlippage: '',
                });
            }
            return clearedValues;
        }
        if (!poolData || poolData.tokens.length !== 2) {
            setTokenValues((prev) => (Object.assign(Object.assign({}, prev), { [tokenSymbol]: value })));
            return { [tokenSymbol]: value };
        }
        const immediateResult = {
            [tokenSymbol]: value,
            [((_b = poolData.tokens.find((t) => t.symbol !== tokenSymbol)) === null || _b === void 0 ? void 0 : _b.symbol) || '']: '',
        };
        setTokenValues((prev) => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { [tokenSymbol]: value, [((_a = poolData.tokens.find((t) => t.symbol !== tokenSymbol)) === null || _a === void 0 ? void 0 : _a.symbol) || '']: '' }));
        });
        if (poolData.strategyType !== 'Leveraged Yield Farming' &&
            poolData.tokens.length === 2 &&
            activeTabIndex === 0 &&
            isZapInActive &&
            parseFloat(value) === 0) {
            setZapInQuoteDetails({
                zapInLoader: true,
                zapInQuoteLoader: false,
                poolId: poolId || '',
                activeToken: tokenSymbol,
                poolDetailsPage: true,
            });
        }
        if (poolData.strategyType !== 'Leveraged Yield Farming' &&
            poolData.tokens.length === 2 &&
            activeTabIndex === 0 &&
            isZapInActive &&
            parseFloat(value) > 0) {
            fetchZapInQuote(value, tokenSymbol === poolData.tokens[0].symbol, slippage, poolData.tokens);
        }
        else {
            calculateTokenRatios(tokenSymbol, value, poolData.tokens);
        }
        // calculateTokenRatios(tokenSymbol, value, poolData.tokens);
        return immediateResult;
    };
    const handleMaxClick = (tokenSymbol) => {
        var _a;
        setIsMaxClicked(true);
        const token = poolData === null || poolData === void 0 ? void 0 : poolData.tokens.find((t) => t.symbol === tokenSymbol);
        if (!token)
            return;
        const maxValue = token.walletBalance;
        if (!maxValue || parseFloat(maxValue) === 0) {
            return;
        }
        if (poolData && poolData.tokens.length === 2) {
            const immediateValues = {
                [tokenSymbol]: maxValue,
                [((_a = poolData.tokens.find((t) => t.symbol !== tokenSymbol)) === null || _a === void 0 ? void 0 : _a.symbol) || '']: '',
            };
            setTokenValues(immediateValues);
            if (poolData.strategyType !== 'Leveraged Yield Farming' &&
                poolData.tokens.length === 2 &&
                activeTabIndex === 0 &&
                isZapInActive) {
                fetchZapInQuote(maxValue, tokenSymbol === poolData.tokens[0].symbol, slippage, poolData.tokens);
            }
            else {
                calculateTokenRatios(tokenSymbol, maxValue, poolData.tokens);
            }
            // calculateTokenRatios(tokenSymbol, maxValue, poolData.tokens);
        }
        else {
            setTokenValues((prev) => (Object.assign(Object.assign({}, prev), { [tokenSymbol]: maxValue })));
        }
    };
    const handleBackClick = () => {
        if (window.history.length > 1) {
            window.history.back();
        }
        else {
            navigate('/');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "theme-bg-alphafi-main-body min-h-screen mx-auto px-[20px] lg:px-[72px] xl:px-[unset] mt-[-1px]", children: _jsxs("div", { className: "w-full xl:max-w-[1390px] flex flex-col justify-center mx-auto md:pt-1", children: [_jsx("div", { className: "xl:pb-[39px] pb-[50px]", children: _jsx(PoolDetailsV1, { tokens: poolData.tokens.map((token) => ({
                                    symbol: token.symbol,
                                    name: token.name,
                                    icon: token.icon,
                                })), protocolIcons: Array.isArray(poolData.protocol_icon)
                                    ? poolData.protocol_icon
                                    : [poolData.protocol_icon], name: poolData.name, desc1: poolData.name === 'ALPHA'
                                    ? []
                                    : poolData.protocolType
                                        ? poolData.protocolType.map((type) => ({ name: type }))
                                        : [], desc2: poolData.name === 'ALPHA'
                                    ? []
                                    : poolData.strategyType && poolData.strategyType !== 'Leveraged Yield Farming'
                                        ? [{ name: poolData.strategyType }]
                                        : [], handleBackClick: handleBackClick, backArrowIcon: themeName === 'dark' ? getIcon('backWhiteIcon') : getIcon('backBlackIcon'), backArrowIconMobile: themeName === 'dark'
                                    ? getIcon('backWhiteMobileIcon')
                                    : getIcon('backBlackMobileIcon') }) }), _jsx("div", { className: "xl:pb-[27px] pb-[30.98px]", children: ((_a = poolData.protocolType) === null || _a === void 0 ? void 0 : _a.includes('Leveraged Yield Farming')) ? (_jsx(PoolInfoCardV1, { poolStats: {
                                    firstSectionStats: [
                                        {
                                            label: 'TVL',
                                            value: '$' + poolData.tvl,
                                            info: poolId &&
                                                (protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) &&
                                                ((_b = protocolData.pools_data[poolId]) === null || _b === void 0 ? void 0 : _b.tvl_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: (((_c = protocolData.pools_data[poolId]) === null || _c === void 0 ? void 0 : _c.tvl_hover) || []).map((item, index, array) => ({
                                                            label: item.label,
                                                            value: array.length > 1
                                                                ? index === array.length - 1
                                                                    ? (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                        ? parseFloat(item.value).toFixed(2) + '%'
                                                                        : '0%'
                                                                    : (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                        ? '$' + commaFy(parseFloat(item.value).toFixed(2))
                                                                        : '$0'
                                                                : (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                    ? '$' + commaFy(parseFloat(item.value).toFixed(2))
                                                                    : '$0',
                                                        })),
                                                        isPointerVisible: false,
                                                    },
                                                }
                                                : undefined,
                                        },
                                        {
                                            label: 'Daily',
                                            value: poolData.daily,
                                            info: (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: ((poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr_hover) || []).map((item) => ({
                                                            label: item.label,
                                                            value: (item === null || item === void 0 ? void 0 : item.value)
                                                                ? isNaN(parseFloat(item.value))
                                                                    ? '0'
                                                                    : parseFloat(item.value).toFixed(4) + '%'
                                                                : '0%',
                                                        })),
                                                        isPointerVisible: false,
                                                    },
                                                }
                                                : undefined,
                                        },
                                        {
                                            label: 'APY',
                                            value: poolData.apy,
                                            info: poolId &&
                                                (protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) &&
                                                ((_d = protocolData.pools_data[poolId]) === null || _d === void 0 ? void 0 : _d.apy_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: (((_e = protocolData.pools_data[poolId]) === null || _e === void 0 ? void 0 : _e.apy_hover) || []).map((item) => ({
                                                            label: item.label,
                                                            value: (item === null || item === void 0 ? void 0 : item.value)
                                                                ? isNaN(parseFloat(item.value))
                                                                    ? '0'
                                                                    : parseFloat(item.value).toFixed(2) + '%'
                                                                : '0%',
                                                        })),
                                                        isPointerVisible: false,
                                                        infotext: `Compounding ${poolData.protocol_name} Protocol APR Multiple Times a Day`,
                                                    },
                                                }
                                                : undefined,
                                        },
                                        {
                                            label: 'Leverage',
                                            value: (poolData === null || poolData === void 0 ? void 0 : poolData.leverage) || '0',
                                        },
                                    ],
                                    secondSectionStats: [
                                        {
                                            label: 'Your Deposit',
                                            value: '$' + poolData.yourDeposit,
                                        },
                                        {
                                            label: 'Last Compound',
                                            value: poolData.lastCompoundTime || '',
                                        },
                                    ],
                                } })) : (_jsx(PoolInfoCardV1, { poolStats: {
                                    firstSectionStats: [
                                        {
                                            label: 'TVL',
                                            value: '$' + poolData.tvl,
                                            info: poolId &&
                                                (protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) &&
                                                ((_f = protocolData.pools_data[poolId]) === null || _f === void 0 ? void 0 : _f.tvl_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: (((_g = protocolData.pools_data[poolId]) === null || _g === void 0 ? void 0 : _g.tvl_hover) || []).map((item, index, array) => ({
                                                            label: item.label,
                                                            value: array.length > 1
                                                                ? index === array.length - 1
                                                                    ? (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                        ? parseFloat(item.value).toFixed(2) + '%'
                                                                        : '0%'
                                                                    : (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                        ? '$' + commaFy(parseFloat(item.value).toFixed(2))
                                                                        : '$0'
                                                                : (item === null || item === void 0 ? void 0 : item.value) && !isNaN(parseFloat(item.value))
                                                                    ? '$' + commaFy(parseFloat(item.value).toFixed(2))
                                                                    : '$0',
                                                        })),
                                                        isPointerVisible: false,
                                                    },
                                                }
                                                : undefined,
                                        },
                                        {
                                            label: 'Daily',
                                            value: poolData.daily,
                                            info: (poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: ((poolDetailsData === null || poolDetailsData === void 0 ? void 0 : poolDetailsData.daily_apr_hover) || []).map((item) => ({
                                                            label: item.label,
                                                            value: (item === null || item === void 0 ? void 0 : item.value)
                                                                ? isNaN(parseFloat(item.value))
                                                                    ? '0'
                                                                    : parseFloat(item.value).toFixed(4) + '%'
                                                                : '0%',
                                                        })),
                                                        isPointerVisible: false,
                                                    },
                                                }
                                                : undefined,
                                        },
                                        {
                                            label: 'APY',
                                            value: poolData.apy,
                                            info: poolId &&
                                                (protocolData === null || protocolData === void 0 ? void 0 : protocolData.pools_data) &&
                                                ((_h = protocolData.pools_data[poolId]) === null || _h === void 0 ? void 0 : _h.apy_hover)
                                                ? {
                                                    icon: getIcon('infoIcon'),
                                                    tooltip: {
                                                        items: (((_j = protocolData.pools_data[poolId]) === null || _j === void 0 ? void 0 : _j.apy_hover) || []).map((item) => ({
                                                            label: item.label,
                                                            value: (item === null || item === void 0 ? void 0 : item.value)
                                                                ? isNaN(parseFloat(item.value))
                                                                    ? '0'
                                                                    : parseFloat(item.value).toFixed(2) + '%'
                                                                : '0%',
                                                        })),
                                                        isPointerVisible: false,
                                                        infotext: `Compounding ${poolData.protocol_name} Protocol APR Multiple Times a Day`,
                                                    },
                                                }
                                                : undefined,
                                        },
                                    ],
                                    secondSectionStats: [
                                        {
                                            label: 'Your Deposit',
                                            value: '$' + poolData.yourDeposit,
                                        },
                                        {
                                            label: 'Last Compound',
                                            value: poolData.lastCompoundTime || '',
                                        },
                                    ],
                                } })) }), _jsxs("div", { className: "flex flex-col-reverse xl:flex-row xl:justify-between gap-auto gap-y-[20px] md:gap-y-[unset] pb-[20px]", children: [((_k = poolData.rewardsBreakdown) === null || _k === void 0 ? void 0 : _k.items) && ((_l = poolData.rewardsBreakdown) === null || _l === void 0 ? void 0 : _l.items.length) > 0 && (_jsx("div", { className: "mt-[20px] xl:mt-[unset]", children: _jsx(RewardsBreakdownV1, { title: "Rewards Breakdown", text: ((_m = poolData.rewardsBreakdown) === null || _m === void 0 ? void 0 : _m.text) || [], firstCard: [
                                            {
                                                title: `${poolData.name} Vault`,
                                                tokens: poolData.tokens.map((token) => ({
                                                    symbol: token.symbol,
                                                    name: token.name,
                                                    icon: token.icon,
                                                })),
                                                items: ((_o = poolData.rewardsBreakdown) === null || _o === void 0 ? void 0 : _o.items) || [],
                                                tooltip: 'Rewards are converted into the deposit token and reinvested every 2 hours, increasing your holdings.',
                                            },
                                        ], 
                                        // Hide arrow and card for now if needed in future we can add them back
                                        // secondCard={
                                        //   poolData.name === 'ALPHA' ? undefined : poolData.rewardsBreakdown?.secondCard
                                        // }
                                        firstArrow: getImage('firstArrowWebMob') }) })), _jsx(NavTabsV1, { tokens: poolData.tokens.map((token) => ({
                                        symbol: token.symbol,
                                        name: token.name,
                                        icon: token.icon,
                                        walletBalance: token.walletBalance,
                                        price: token.price,
                                        value: tokenValues[token.symbol],
                                    })), activeTab: activeTabIndex, onTabChange: (tabIndex) => {
                                        setActiveTabIndex(tabIndex);
                                        setTokenValues({});
                                        setIsMaxClicked(false);
                                        setZapInQuoteDetails({
                                            zapInLoader: true,
                                            zapInQuoteLoader: false,
                                            poolId: poolId || '',
                                            poolDetailsPage: true,
                                        });
                                    }, onTokenValueChange: (tokenSymbol, value) => {
                                        return updateTokenValues(tokenSymbol, value);
                                    }, onMaxClick: handleMaxClick, onDeposit: () => handleDeposit(tokenValues), onWithdraw: () => handleWithdraw(tokenValues), onZapInAndDeposit: () => handleZapInAndDeposit(), isLoading: loading ||
                                        (isZapInActive &&
                                            (zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.poolId) === poolId &&
                                            (zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.zapInQuoteLoader) &&
                                            (zapInQuoteDetails === null || zapInQuoteDetails === void 0 ? void 0 : zapInQuoteDetails.zapInLoader)), navTabs: poolData.navTabs, isPoolDescription: true, balanceText: activeTabIndex === 0 || activeTabIndex === undefined ? 'In Wallet:' : 'In Vault:', isButtonDisabled: (() => {
                                        var _a, _b;
                                        const rangeStatus = (_b = (_a = poolData.positionRange) === null || _a === void 0 ? void 0 : _a.find((item) => item.rangeStatus)) === null || _b === void 0 ? void 0 : _b.rangeStatus;
                                        const buttonState = getButtonState(tokenValues, activeTabIndex, poolData.tokens, isMaxClicked, rangeStatus);
                                        return buttonState.disabled;
                                    })(), buttonText: (() => {
                                        const buttonState = getButtonState(tokenValues, activeTabIndex, poolData.tokens, isMaxClicked);
                                        return buttonState.text;
                                    })(), walletConnectFunctionality: address ? undefined : walletConnectFunctionality, zapinIcon: themeName === 'dark' && isZapInActive
                                        ? getIcon('zapInIcon')
                                        : themeName === 'dark' && !isZapInActive
                                            ? getIcon('zapInIconDarkTheme')
                                            : themeName !== 'dark' && isZapInActive
                                                ? getIcon('zapInIconDarkTheme')
                                                : themeName !== 'dark' && !isZapInActive
                                                    ? getIcon('zapInIcon')
                                                    : '', switchTokenIcon: themeName === 'dark'
                                        ? getIcon('switchTokenDarkThemeIcon')
                                        : getIcon('switchTokenIcon'), zapInQuoteDetails: zapInQuoteDetails, isZapInActive: isZapInActive, setIsZapInActive: setIsZapInActive, slippage: slippage, setSlippage: setSlippage, poolId: poolId || '' })] }), poolData.positionRange && (_jsx("div", { className: "pb-[20px]", children: _jsx(PositionRangeV1, { title: "Position Range", positionStats: poolData.positionRange.map((item) => ({
                                    label: item.title,
                                    value: item.value || '',
                                    rangeStatus: item.rangeStatus,
                                    poolName: item.poolName,
                                })) }) })), poolData.lpBreakdown && (_jsx("div", { className: "pb-[20px]", children: _jsx(LpBreakdownDetailV1, { title: "LP Breakdown", tokenShareInPool: poolData.lpBreakdown.tokenShareInPool, assets: poolData.lpBreakdown.assets, activeTab: lpBreakdownActiveTab, onTabChange: setLpBreakdownActiveTab, tokenIcons: poolData.lpBreakdown.tokenIcons }) })), poolData.strategyDetails && (_jsx("div", { className: "pb-[20px]", children: _jsx(VaultDetailsStrategyV1, { title: poolData.strategyDetails.title, contracts: poolData.strategyDetails.contracts, strategy: poolData.strategyDetails.strategy, fees: poolData.strategyDetails.fees, audits: poolData.strategyDetails.audits, stakingFlow: poolData.strategyDetails.stakingFlow, poolName: poolData.name, className: "w-full" }) })), poolData.assetDetails && (_jsx("div", { className: "pb-[20px]", children: _jsx(AssetDetailsV1, { title: "Asset Details", tokens: poolData.assetDetails.map((asset) => ({
                                    name: asset.name,
                                    symbol: asset.symbol,
                                    price: parseFloat(asset.price),
                                    logoUrl: asset.logoUrl,
                                    description: asset.description,
                                    links: asset.links,
                                })), icons: {
                                    websiteIcon: themeName === 'dark' ? getIcon('websiteWhite') : getIcon('websiteIcon'),
                                    contractIcon: themeName === 'dark' ? getIcon('contractWhite') : getIcon('contractIcon'),
                                    docsIcon: themeName === 'dark' ? getIcon('docsWhite') : getIcon('docsIcon'),
                                } }) }))] }) }), _jsx(NotificationComp, { isOpen: isNotificationOpen, setIsOpen: setIsNotificationOpen, info: notificationInfo })] }));
};
export default PoolDetailsPage;
